export enum PpwrDocumentHandlingModeDto {
  Delete = 0,
  Recreate = 1
}
